import axios, { AxiosRequestConfig, Method } from 'axios';

import { getCookie } from './helpers';

export interface RequestWithCheckVersionProps extends Omit<AxiosRequestConfig, 'method' | 'url'> {
  enabledCheckVercion?: boolean;
}

axios.defaults.headers.common['Accept'] = 'application/json';
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common['X-CSRFToken'] = getCookie('csrftoken');

export const requestWithCheckVersion = (
  method: Method,
  url: string,
  options: RequestWithCheckVersionProps = {},
) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { enabledCheckVercion, ...restOptions } = options;

  return axios({ method, url, ...restOptions }).then(response => {
    return response;
  });
};
